import { WORK_TYPES } from '@felix/domain';

/**
 * Bakım kategorisi ve etkinliği süzgeçleri (DNV-CP-0206 Sec.2 [4.3] e–f, [4.4] b–c; ADR 0133):
 * kategori iş emri türünden türetilir (planlı iş önleyici, plansız / düzeltici / arıza düzeltici),
 * etkinlik işin iş türüdür (Work Type). Saf modül; ekranlar ve testler kullanır.
 */
export const MAINTENANCE_CATEGORIES = ['preventive', 'corrective'] as const;
export type MaintenanceCategory = (typeof MAINTENANCE_CATEGORIES)[number];

/** İş emri türünün kategorisi: `planned` önleyici, diğerleri (unplanned, corrective, breakdown) düzeltici. */
export function categoryOf(kind: string | null | undefined): MaintenanceCategory | null {
  if (!kind) return null;
  return kind === 'planned' ? 'preventive' : 'corrective';
}

/** Süzgeç değeri: boş metin "hepsi". */
export function matchesCategory(kind: string | null | undefined, category: string): boolean {
  return category === '' || categoryOf(kind) === category;
}

/** Etkinlik süzgeci: boş metin "hepsi"; iş türü olmayan (görevsiz) iş emri yalnız "hepsi"de. */
export function matchesActivity(workType: string | null | undefined, activity: string): boolean {
  return activity === '' || workType === activity;
}

/** Etkinlik seçenekleri: kütüphanedeki sıra, sonra listede görülen ama kütüphanede olmayan eski değerler. */
export function activityOptions(seen: readonly (string | null | undefined)[]): string[] {
  const known: readonly string[] = WORK_TYPES;
  const extra = [...new Set(seen.filter((v): v is string => !!v && !known.includes(v)))].sort();
  return [...known, ...extra];
}
